<template>
  <CRow>
    <CCol sm="12" class="rowSegments mt-4">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
      <CRow class="rowSegments">
        <CCol sm="12">
          <CRow>
            <CCol sm="12">
              <h1 class="mb-4 mt-5 titlePage font-weight-normal text-capitalize" style="color: #22252b">
                {{ $t('audience.segment.edit.header') }}
              </h1>
              <CAlert :color="alertClass" closeButton v-if="alertMessage" :show.sync="currentAlertCounter">
                <center>
                  <strong>{{ alertMessage }}</strong>
                </center>
                <CProgress :max="10" :value="currentAlertCounter" height="3px" :color="alertClass" animate />
              </CAlert>
              <p class="boxTitle mt-3">
                {{ $t('audience.segment.edit.subtitle') }}
              </p>
              <div class="d-flex flex-column mb-4">
                <div class="d-flex justify-content-end">
                  <button @click="openModalConfirmCancel" class="btn btn-white font-sm py-3 px-5 text-gray-700" style="position: relative">
                    {{ $t('audience.segment.edit.btn.cancel') }}
                  </button>
                  <transition name="fade" v-if="modalConfirmCancel">
                    <div class="dataTable__popUp popUp" style="top: 205px">
                      <div class="popUp__body shadow-sm">
                        <div class="confirmationDelete">
                          <div class="confirmationDelete__header">
                            <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                              {{ $t('audience.segment.edit.btn.confirm-cancel') }}
                            </p>
                          </div>
                          <div class="confirmationDelete__body">
                            <p class="confirmationDelete__description text-gray-700">
                              {{ $t('audience.segment.edit.text.click-confirm') }}
                            </p>
                          </div>
                          <div class="confirmationDelete__footer">
                            <div class="confirmationDelete__actions">
                              <CButton class="confirmationDelete__btn btn btn-primary" @click="$router.go(-1)">
                                {{ $t('audience.segment.edit.btn.confirm') }}
                              </CButton>
                              <CButton class="confirmationDelete__btn" @click="closeModalCancel" type="link">
                                {{ $t('audience.segment.edit.btn.cancel') }}
                              </CButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="12">
          <CRow>
            <CCol sm="12">
              <div class="d-flex justify-content-center" v-if="loadingSegmentDetail">
                <CSpinner class="my-3" color="primary" style="width: 4rem; height: 4rem" />
              </div>
              <template v-else>
                <template v-for="(seg, indexSeg) in segments.values">
                  <div class="segmentBlock" v-for="(item, indexOr) in seg.values" :key="indexOr + '-' + (segments.values.length + 1)">
                    <div class style="max-width: 95%">
                      <CSelect
                        placeholder="Select"
                        class="m-2 d-inline-block"
                        :options="getGroupOptions"
                        :value.sync="item.group"
                        @change="changeGroup($event.target.value, indexSeg, indexOr)"
                      />
                      <CSelect
                        v-if="item.group !== null"
                        placeholder="Select"
                        class="m-2 d-inline-block"
                        :options="getValueByGroupName(item.group)"
                        :value.sync="item.key"
                        @change="addKey($event.target.value, indexSeg, indexOr)"
                      />

                      <template
                        v-if="
                          (item.key && getKeyType(item.key) === 'STRING') ||
                          (item.key && getKeyType(item.key) === 'EMAIL') ||
                          (item.key && getKeyType(item.key) === 'MSISDN') ||
                          (item.key && getKeyType(item.key) === 'NUMBER') ||
                          (item.key && getKeyType(item.key) === 'TAGS')
                        "
                      >
                        <CSelect
                          :key="item.key + 'operator'"
                          placeholder="Select"
                          class="m-2 d-inline-block"
                          :options="getOperationsInKeyGroup(item.key, item.next.op)[0]"
                          :value.sync="item.next.op"
                          @change="changeOperator($event.target.value, indexSeg, indexOr)"
                        />

                        <CInput
                          placeholder="write here..."
                          class="d-inline-block m-2"
                          :value.sync="item.next.value"
                          @keyup="addTextValueToJson(indexSeg, indexOr, $event.target.value)"
                          @focusout="getClientOverview(true)"
                          v-if="item.key != '_MetaData.Tags'"
                        />

                        <CSelect
                          v-if="item.key == '_MetaData.Tags'"
                          placeholder="Select a tag"
                          class="m-2 d-inline-block"
                          :options="tags"
                          :value.sync="item.next.value"
                          @focusout="getClientOverview(true)"
                          @change="addTagValueToJson(indexSeg, indexOr, $event.target.value)"
                        />
                      </template>

                      <template v-if="item.key && getKeyType(item.key) === 'DATE'">
                        <!-- <CSelect
                          :key="item.key + 'operator'"
                          placeholder="Select"
                          class="m-2 d-inline-block"
                          :options="getOperationsInKeyGroup(item.key)[0]"
                          :value.sync="form[item.op + indexSeg + indexOr + 'operator']"
                          @change="changeOperator(form[item.op + indexSeg + indexOr + 'operator'], indexSeg, indexOr)"
                        /> -->
                        <CSelect
                          :key="item.key + 'operator'"
                          placeholder="Select"
                          class="m-2 d-inline-block"
                          :options="getOperationsInKeyGroup(item.key)[0]"
                          :value.sync="form[item.op + indexSeg + indexOr + 'operator']"
                          @change="changeOperator($event.target.value, indexSeg, indexOr)"
                        />
                        <CInput
                          type="date"
                          horizontal
                          class="d-inline-block m-2"
                          style="min-width: 235px"
                          v-model="inputCustom"
                          @input="addCustomToJson(indexSeg, indexOr)"
                        />
                      </template>

                      <template v-if="item.key && getKeyType(item.key) === 'boolean'">
                        <CSelect
                          :key="item.key + 'operator'"
                          placeholder="Select"
                          class="m-2 d-inline-block"
                          :options="getOperationsInKeyGroup(item.key)[0]"
                          :value.sync="form[item.op + indexSeg + indexOr + 'operator']"
                          @change="changeOperator(form[item.op + indexSeg + indexOr + 'operator'], indexSeg, indexOr)"
                        />
                        <CSelect
                          :key="item.key + 'input'"
                          placeholder="Select"
                          class="m-2 d-inline-block"
                          :options="getValuesInKeyGroup(item.key)"
                          :value.sync="form[item.selected + item.key + indexSeg + indexOr + 'value']"
                          @change="addKey2(form[item.selected + item.key + indexSeg + indexOr + 'value'], indexSeg, indexOr)"
                        />
                      </template>
                      <br />
                      <br />
                      <div v-if="seg.values.length - 1 == indexOr">
                        <button @click="addOrCondition(indexSeg)" class="btn mt-2" style="padding: 0px; margin: 0px">
                          <img style="width: 25px; height: 25px; margin-top: -10px" src="img/site/addCondition.png" />
                        </button>
                        <span class="addText">ADD</span>
                      </div>
                    </div>

                    <div class="col-1 closeCondition">
                      <span @click="deleteOrCondition(indexSeg, indexOr)" class="closeConsitionBtn"> x </span>
                    </div>
                    <span v-if="indexOr > 0 && seg.values.length - 1 > 0" class="newPlus">{{ $t('audience.segment.conditions.or') }}</span>
                  </div>
                  <div :key="indexSeg + segments.values.length" class="line">
                    <span v-if="segments.values.length - 1 > 0 && segments.values.length - 1 != indexSeg" class="lineAndNew text-uppercase">{{
                      $t('audience.segment.conditions.and')
                    }}</span>
                    <span v-if="segments.values.length - 1 == indexSeg" class="lineAndDisabled text-uppercase">{{
                      $t('audience.segment.conditions.and')
                    }}</span>
                  </div>
                </template>

                <div class="btnAddAnd mb-5" @click="addCondition()">
                  <img src="img/site/addCondition.png" />
                  <span class="text-uppercase">{{ $t('audience.segment.conditions.and-a-conditions') }}</span>
                </div>

                <div class="col-md-12 mb-1">
                  <div class="d-flex justify-content-between mb-3">
                    <div>
                      <button @click="openModalSaveSegment" class="btn btn-primary btn-segment-create">UPDATE SEGMENT</button>

                      <transition name="fade" v-if="modalSaveSegment">
                        <div class="dataTable__popUp popUp" style="margin-top: 0px">
                          <div class="popUp__body shadow-sm">
                            <div class="confirmationDelete">
                              <div class="confirmationDelete__header">
                                <p class="confirmationDelete__title font-weight-semi-bold mb-1">Confirm the segment name</p>
                              </div>
                              <div class="confirmationDelete__body mb-4">
                                <input type="text" class="form-control" v-model="segmentName" />
                              </div>
                              <div class="confirmationDelete__footer">
                                <div class="confirmationDelete__actions">
                                  <CButton class="confirmationDelete__btn btn btn-primary" @click="updateSegment"> confirm </CButton>
                                  <CButton class="confirmationDelete__btn" @click="closeModalSaveSegment" type="link"> Cancel </CButton>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 mb-5">
                  <div class="mt-5" style="margin-bottom: 200px">
                    <div class="d-flex justify-content-center" v-if="loadingClientOverview">
                      <CSpinner class="my-3" color="primary" style="width: 4rem; height: 4rem" />
                    </div>
                    <table class="table tableCustom" style="font-size: 0.94rem; color: #a1a8b3" v-if="!loadingClientOverview">
                      <thead>
                        <tr>
                          <th>EMAIL ADRESS</th>
                          <th>NAME</th>
                          <th>OPT IN & OPT OUT</th>
                          <th>TAGS</th>
                          <th>LAST CHANGE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="seg in recipients" :key="seg._id" class="trLine">
                          <td style="width: 20%">{{ seg.Field1 }}</td>
                          <td style="width: 15%">{{ seg.Field2 }}</td>
                          <td class="d-flex justify-content-center p-0">
                            <OptInOut :opt="{ item: seg }" />
                          </td>
                          <td style="width: 15%">
                            <span v-for="(tags, index) in seg._MetaData.Tags" :key="tags">
                              <template v-if="index < 3"> {{ tags }}, </template>
                            </span>
                          </td>
                          <td style="width: 20%">
                            {{ seg._MetaData.UpdatedDatetime }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="d-flex justify-content-between" v-if="!loadingClientOverview">
                      <div class="boxPag" @click="previousPage()" :class="{ 'box-pag-bg-disable': verifyPagination() }">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i>
                      </div>
                      <div class="paginationText">
                        {{ startCountPag }} - {{ counterTable(overview.contacts) }} of
                        {{ overview.contacts }}
                      </div>
                      <div
                        class="boxPag"
                        @click="nextPage(overview.contacts)"
                        :class="{ 'box-pag-bg-disable': verifyPaginationNext(overview.contacts) }"
                      >
                        <i class="fa fa-chevron-right" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import services from '@/services.js'
import Overview from '../components/OverView'
import vSelect from 'vue-select'
import MenssageAlert from '@/components/MenssageAlert'
import { getErrorMessage } from '@/utils/errorHandling.js'
import OptInOut from '../../../components/table/OptInOut.vue'

export default {
  name: 'SegmentsEdit',
  components: {
    Overview,
    vSelect,
    MenssageAlert,
    OptInOut,
  },
  data() {
    return {
      segmentName: '',
      groupName: '',
      currentAlertCounter: 10,
      alertMessage: '',
      alertClass: '',
      form: [['']],
      inputText: [['']],
      inputCustom: '',
      segments: {
        op: 'and',
        values: [
          {
            op: 'or',
            values: [
              {
                group: null,
                key: '',
                value: '',
                op: '',
                next: {
                  key: '',
                  value: '',
                  op: '',
                  next: {},
                },
              },
            ],
          },
        ],
      },
      groups: [],
      operators: [],
      values: [],
      overview: {},
      recipients: [],
      keyValues: [],
      page: 0,
      count: 10,
      startCountPag: 1,
      endCountPag: 10,
      modalConfirmCancel: false,
      modalSaveSegment: false,
      loadingSegmentDetail: false,
      loadingClientOverview: false,
      tags: [],
      messages: [],
    }
  },
  mounted() {
    this.getClientSegment()
    this.getOperator()
    this.getSegmentDetail()
    this.getAudienceScheme()
  },
  methods: {
    getAudienceScheme() {
      services
        .audienceSchema(this.$route.params.organizationId)
        .then((schema) => {
          for (var i = 0; i < schema.data.data.tags.length; i++) {
            this.tags.push({
              value: schema.data.data.tags[i],
              label: schema.data.data.tags[i],
            })
          }
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },

    getSegmentDetail() {
      this.loadingSegmentDetail = true
      services
        .getSegment(this.organizationId, this.segmentIdGuid)
        .then((response) => {
          const segmentData = response.data.data

          this.segmentName = segmentData.name
          this.segments = segmentData.query

          this.getClientOverview()
          this.addKeys()
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
        })
        .finally(() => {
          this.loadingSegmentDetail = false
        })
    },

    addCondition() {
      this.segments.values.push({
        op: 'or',
        values: [
          {
            group: null,
            key: '',
            value: '',
            op: '',
            next: {
              key: '',
              value: '',
              op: '',
              next: {},
            },
          },
        ],
      })

      this.inputText.push([''])
      this.form.push([''])
    },

    getValueByGroupName(groupName) {
      if (!this.groups || this.groups.length <= 0) return
      let gp = this.groups.find((item) => item.group === groupName)
      return gp.values.map((item) => {
        return {
          value: item.key,
          label: item.name,
        }
      })
    },

    getValuesByKey(key) {
      var len = this.groups.length
      let lv = []
      for (var i = 0; i < len; i++) {
        if (!this.values.length) {
          this.recursiveVerifyKey(this.groups[i].values, key)
        }
        lv = this.values
        this.values = []
        if (lv.length) {
          break
        }
      }

      return lv.map((item) => {
        return {
          value: item.key,
          label: item.value,
        }
      })
    },

    recursiveVerifyKey(item, key) {
      if (!item?.length) {
        return
      }

      if (this.values.length) {
        return
      }
      for (let i = 0; i < item.length; i++) {
        if (item[i].key === key) {
          this.values = item[i].values
          break
        }
        this.keyValues.push({
          key: item[i].key,
          type: item[i].type,
          values: item[i].values,
        })

        this.recursiveVerifyKey(item[i].values, key)
      }
    },

    getValuesInKeyGroup(key) {
      let values = []
      for (let i = 0; i < this.keyValues.length; i++) {
        if (this.keyValues[i].key === key) {
          values = this.keyValues[i].values
          break
        }
      }

      return values.map((item) => {
        return {
          value: item.key,
          label: item.value,
        }
      })
    },

    getKeyType(key) {
      let type = null

      // this.keyValues.find((item) => {
      //   if (item.key === key) {
      //     type = item.type
      //   }
      // })
      const value = this.keyValues.find((el) => el.key === key)
      return value?.type
    },

    getOperationsInKeyGroup(key, opValue = null) {
      let type = null
      // this.keyValues.find((item) => {
      //   if (item.key === key) {
      //     type = item.type
      //   }
      // })
      const value = this.keyValues.find((item) => item.key === key)
      type = value.type

      if (type === 'EMAIL') {
        type = 'STRING'
      }

      if (type === 'MSISDN') {
        type = 'STRING'
      }

      let result = this.operators
        .map((item) => {
          if (item.type === type) {
            return item.operators
              .filter((el) => el.isActive)
              .map((prop) => {
                return {
                  value: prop.name,
                  label: prop.label,
                }
              })
          }
        })
        .filter((element) => element !== undefined)

      if (opValue && result.length > 0) {
        if (!result[0].some((el) => el.label == opValue)) {
          result[0].push({
            label: opValue,
            value: opValue,
            disabled: true,
          })
        }
      }

      return result
    },

    addOrCondition(indexSeg) {
      this.segments.values[indexSeg].values.push({ group: null, key: '', value: '', op: null, next: { key: '', value: '', op: '', next: {} } })
    },

    getSelectOptions(item) {
      return {
        value: item.key,
        label: item.next.value,
      }
    },

    deleteOrCondition(indexSeg, indexOr) {
      if (indexSeg == 0 && indexOr > 0) {
        this.segments.values[indexSeg].values.splice(indexOr, 1)
      } else if (indexSeg > 0 && indexOr > 0) {
        this.segments.values[indexSeg].values.splice(indexOr, 1)
      } else if (indexSeg > 0 && indexOr == 0) {
        this.segments.values.splice(indexSeg, 1)
      }

      this.waitToGetOverView()
    },

    changeGroup(group, indexSeg, indexOr) {
      this.groupName = group
      // let len = this.groups.length
      // let groupValues = []
      // let keys = []

      // for (let i = 0; i < len; i++) {
      //   if (this.groups[i].group == group) {
      //     groupValues = this.groups[i].values
      //     let len1 = groupValues.length
      //     for (let j = 0; j < len1; j++) {}
      //   }
      // }

      this.segments.values[indexSeg].values.splice(indexOr, 1, {
        group: group,
        key: '',
        value: '',
        op: '',
        next: {
          key: '',
          value: '',
          op: '',
          next: {},
        },
      })

      this.addKeys()
    },

    addKey(key, indexSeg, indexOr) {
      this.segments.values[indexSeg].values[indexOr].key = key
      this.segments.values[indexSeg].values[indexOr].value = key
      this.waitToGetOverView()
      //this.inputText = '';
      return
    },

    addKey2(key, indexSeg, indexOr) {
      this.segments.values[indexSeg].values[indexOr].next.key = key
      this.segments.values[indexSeg].values[indexOr].next.value = key
      this.waitToGetOverView()
      return
    },

    addCustomToJson(indexSeg, indexOr) {
      this.segments.values[indexSeg].values[indexOr].next.key = this.inputCustom.toString()
      this.segments.values[indexSeg].values[indexOr].next.value = this.inputCustom.toString()
      return
    },

    addTextValueToJson(indexSeg, indexOr, value) {
      this.segments.values[indexSeg].values[indexOr].next.key = '' //vazio pois o backend está com bug, ver conversa com Paulo
      this.segments.values[indexSeg].values[indexOr].next.value = value
      this.inputText[indexSeg][indexOr] = value

      this.waitToGetOverView()
    },

    addTagValueToJson(indexSeg, indexOr, value) {
      this.segments.values[indexSeg].values[indexOr].next.key = ''
      this.segments.values[indexSeg].values[indexOr].next.value = value
      this.inputText[indexSeg][indexOr] = value

      this.waitToGetOverView()
    },

    waitToGetOverView() {
      setTimeout(() => {
        this.getClientOverview()
      }, 1000)
    },

    changeOperator(op, indexSeg, indexOr) {
      this.segments.values[indexSeg].values[indexOr].next.op = op
      this.form[indexSeg][indexOr] = op
      this.waitToGetOverView()
    },

    getOperator() {
      services
        .getOperators()
        .then((response) => {
          this.operators = response.data.data
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
        })
    },

    getClientSegment() {
      services
        .getClientSegment(this.organizationId)
        .then((response) => {
          this.groups = response.data.data
          this.getValuesByKey('Nothing')
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
        })
    },

    addKeys() {
      let groups = this.groups
      for (var i = 0; i < groups.length; i++) {
        for (var j = 0; j < groups[i].values.length; j++) {
          this.keyValues.push({
            key: groups[i].values[j].key,
            type: groups[i].values[j].type,
            values: groups[i].values[j].values,
            name: groups[i].values[j].name,
          })
        }
      }
    },

    saveSegment() {
      const organizationId = this.organizationId
      const name = this.segmentName
      const query = this.segments
      services
        .postSegment({ organizationId, name, query })
        .then((response) => {
          alert('Save Segments', response.data.status)
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
        })
    },

    getClientOverview() {
      this.loadingClientOverview = true
      let body = {
        pageOptions: {
          count: this.count,
          page: this.page,
        },
        query: this.segments,
      }

      services
        .getClientOverview(this.organizationId, body)
        .then((response) => {
          const responseData = response.data.data
          if (!responseData) return

          this.overview = responseData
          this.recipients = responseData.recipientResult?.recipients
          this.setOverviewValue(responseData)
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
        })
        .finally(() => {
          this.loadingClientOverview = false
        })
    },

    openAlertMessage(alertClass, alertMessage) {
      this.currentAlertCounter = 10
      this.alertClass = alertClass
      this.alertMessage = alertMessage
    },

    openModalConfirmCancel() {
      this.modalConfirmCancel = true
    },

    closeModalCancel() {
      this.modalConfirmCancel = false
    },

    openModalSaveSegment() {
      this.modalSaveSegment = true
    },

    closeModalSaveSegment() {
      this.modalSaveSegment = false
    },

    verifyPagination() {
      if (this.page === 0) {
        return 1
      }

      if (this.page > 0) {
        return 0
      }
    },

    verifyPaginationNext(count) {
      if (count < 10) {
        return 1
      }

      if (count >= 10) {
        return 0
      }
    },

    previousPage() {
      if (this.page === 0) {
        return
      }
      this.startCountPag = this.startCountPag - 10
      this.endCountPag = this.endCountPag - 10
      this.page = this.page - 1
      this.getClientOverview()
    },

    nextPage(count) {
      if (count < 10) {
        return
      }
      this.page = this.page + 1
      this.startCountPag = this.startCountPag + 10
      this.endCountPag = this.endCountPag + 10
      this.getClientOverview()
    },

    updateSegment() {
      if (this.segmentName === '') {
        this.openAlertMessage('danger', 'You must enter a name for this segment.')
        this.scrollTop()
        this.modalSaveSegment = false
      } else {
        let body = {
          organizationId: this.organizationId,
          name: this.segmentName,
          group: 'CONTACT_FIELDS', //rever necessidade de ter o group pois poderão existir vários na msm query
          defaultField: null,
          query: this.segments,
          segmentId: this.segmentIdGuid,
        }

        services
          .updateSegment(this.organizationId, this.segmentIdGuid, body)
          .then((response) => {
            this.modalSaveSegment = false
            this.$router.push({
              name: 'segments-list',
              params: { message: 'Segment ' + this.segmentName + ' successfully updated!', status: 'success' },
            })
          })
          .catch((error) => {
            this.modalSaveSegment = false
            this.openAlertMessage('danger', 'Your query contains errors, please review the applied filters.')
            this.scrollTop()
          })
      }
    },

    scrollTop() {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },

    counterTable(count) {
      if (count < 10) {
        return count
      } else {
        return this.endCountPag
      }
    },

    setOverviewValue(overview) {
      this.$store.commit('UPDATE_OVERVIEW', overview)
    },
  },

  computed: {
    getGroupOptions() {
      let gp = this.groups.map((item) => {
        return {
          value: item.group,
          label: item.group,
        }
      })
      return gp
    },

    segmentId() {
      return this.$route.params.id
    },

    segmentIdGuid() {
      return this.$route.params.segmentIdGuid
    },

    organizationId() {
      return this.$store.state.auth.organizationId
    },
  },

  created() {},
}
</script>
<style scope>
.position-sticky {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 27px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 21px;
  width: 21px;
  left: 6px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #71d875;
}

input:focus + .slider {
  box-shadow: 0 0 1px #71d875;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.dropdown-toggle {
  border: 1px solid #c9c9c9 !important;
}

.btnAddAnd {
  border-radius: 2px;
  -webkit-box-shadow: 1px 9px 4px -7px rgba(181, 181, 181, 0.3);
  -moz-box-shadow: 1px 9px 4px -7px rgba(181, 181, 181, 0.3);
  box-shadow: 1px 9px 4px -7px rgba(181, 181, 181, 0.3);
  border: solid 1px #d1d4da;
  padding: 8px;
  border-radius: 1px;
  text-align: center;
  color: #405a76;
  cursor: pointer;
  background-color: #f5f5f5;
  font-size: 12px;
}

.btnAddAnd img {
  width: 20px;
  height: 20px;
}

.btnAddAnd span {
  text-decoration: underline #405a76;
}

.btn-segment-create {
  color: white !important;
  text-decoration: none !important;
  float: right;
  padding: 0.8rem 1.5rem;
  font-weight: bold;
}

.btn-segment-overview {
  color: #7f889a;
  text-decoration: none !important;
  float: right;
  padding: 0.8rem 1.5rem;
}

.boxTitle {
  font-size: 28px;
  color: #373737;
}

.paginationText {
  color: #a1a8b3;
  line-height: 3;
}

.boxPag {
  background-color: #fff;
  width: 50px;
  height: 45px;
  line-height: 2.9;
  text-align: center;
  color: #d1d4da;
  cursor: pointer;
}

.boxPag:hover {
  background-color: #edeff1;
}

.box-pag-bg-disable {
  background-color: #edeff1 !important;
}

.table td {
  padding: 0.85rem 2rem;
  border-top: none;
}

.trLine:hover {
  background-color: #fff;
  cursor: pointer;
  color: #656971;
  -webkit-box-shadow: -1px -1px 16px -8px rgba(94, 94, 94, 0.73) !important;
  -moz-box-shadow: -1px -1px 16px -8px rgba(94, 94, 94, 0.73) !important;
  box-shadow: -1px -1px 16px -8px rgba(94, 94, 94, 0.73) !important;
  border: none !important;
}

.table {
  background-color: #fff;
  overflow-x: auto;
  white-space: nowrap;
}

.table tr {
  border-top: 2px solid #edeff1;
}

.tableCustom thead {
  border: 0;
}

.tableCustom th {
  vertical-align: middle;
  overflow: hidden;
  border-bottom: 2px solid var(--white);
  font-weight: normal;
  padding: 1.4rem 2rem;
  border-top: 0;
  background: var(--gray-200);
}
</style>
